/**
 * Horizontal scroll wheel translator.
 *
 * Any element with the [data-horizontal-scroll] attribute becomes scrollable by
 * vertical mouse wheel input: deltaY is translated into horizontal scroll.
 * This makes native CSS overflow-x:auto containers usable on a regular mouse
 * (which only produces deltaY) in addition to trackpads (deltaX already works).
 *
 * Trackpad users are unaffected — if the event already has a non-trivial
 * deltaX, we leave it alone so diagonal gestures still feel natural.
 *
 * Usage:
 *   <div class="my-scroller" data-horizontal-scroll>...</div>
 */
(function () {
  'use strict';

  function attach(el) {
    if (el.__hScrollBound) return;
    el.__hScrollBound = true;

    el.addEventListener(
      'wheel',
      function (e) {
        // If the user is already generating horizontal input (trackpad), let
        // the browser handle it natively.
        if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) return;

        // If the container can't scroll horizontally, let the page scroll.
        if (el.scrollWidth <= el.clientWidth) return;

        // If we're at an edge and the wheel would push further past that edge,
        // let the page scroll so the user isn't trapped inside the carousel.
        var atStart = el.scrollLeft <= 0;
        var atEnd = el.scrollLeft + el.clientWidth >= el.scrollWidth - 1;
        if ((atStart && e.deltaY < 0) || (atEnd && e.deltaY > 0)) return;

        e.preventDefault();
        el.scrollLeft += e.deltaY;
      },
      { passive: false }
    );
  }

  function init() {
    document.querySelectorAll('[data-horizontal-scroll]').forEach(attach);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-scan when sections are re-rendered in the theme editor.
  document.addEventListener('shopify:section:load', init);
})();
